import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Columns
name: Columns
category: React - Bulma
---

A `Columns` component based on Bulma `.columns`. This should contain nested `Column`
components. Component will not render if there are no children.

See [Bulma Documentation](http://bulma.io/documentation/columns/basics/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                 |Type            | Default Value             | Required?     |
|-----------------|---------------------------------------------|----------------|---------------------------|---------------|
| isMobile        | Columns begin on mobile devices             | boolean        | false                     | no            |
| isTablet        | Columns begin on tablet devices             | boolean        | true                      | no            |
| isDesktop       | Columns begin on desktop devices            | boolean        | false                     | no            |
| isMultiline     | Columns wrap to additional lines            | boolean        | false                     | no            |
| isCentered      | Columns are centered                        | boolean        | false                     | no            |
| isGapless       | Columns have no spacing between them        | boolean        | false                     | no            |


```html_example
  <Columns isMobile isMultiline isCentered>
    <Column size="two-thirds">
      ...
    </Column>
    <Column isNarrow>
      ...
    </Column>
  </Columns>
```
*/
const Columns = (props) => {
  if (!props.children) return false

  const classes = [
    'columns',
    props.className ? props.className : '',
    props.isMobile ? 'is-mobile' : '',
    props.isTablet ? 'is-tablet' : '',
    props.isDesktop ? 'is-desktop' : '',
    props.isMultiline ? 'is-multiline' : '',
    props.isCentered ? 'is-centered' : '',
    props.isGapless ? 'is-gapless' : '',
  ]

  return (
    <div className={classes.join(' ')}>
      { props.children }
    </div>
  )
}

Columns.defaultProps = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isMultiline: false,
  isCentered: false,
  isGapless: false,
}

Columns.propTypes = {
  // Columns begin on mobile devices
  isMobile: PropTypes.bool,
  // Columns begin on tablet devices
  isTablet: PropTypes.bool,
  // Columns begin on desktop devices
  isDesktop: PropTypes.bool,
  // Columns wrap to additional lines
  isMultiline: PropTypes.bool,
  // Columns are centered
  isCentered: PropTypes.bool,
  // Columns have no spacing between them
  isGapless: PropTypes.bool,
}

export default Columns
